import React, { useMemo } from "react";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import localesListStore from "../../stores/locales-list-store";
import AddLanguageWizardStore, { ADD_LANGUAGE_WIZARD_STEPS } from "../../stores/add-language-wizard-store";
import SelectLanguageStep from "./steps/select-language-step";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { observer } from "mobx-react";
import DownloadTranslationsStep from "./steps/download-translations-step";
import UploadTranslationsStep from "./steps/upload-translations-step";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import AddLanguageWizardStepper from "./add-language-wizard-stepper";
import "./add-language-wizard-modal.scss";

const AddLanguageWizardModal: React.FC = observer(() => {
    const wizardStore = useMemo(() => new AddLanguageWizardStore(localesListStore), []);
    const isLoading = wizardStore.isAddingLocales || wizardStore.isUploadingTranslationsFile;

    return (
        <DefaultModalLayout isCloseDisabled={false} onCloseClicked={() => localesListStore.setIsAddLanguageWizardOpen(false)}>
            <div className="add-language-wizard-modal">
                <div><FontBody1 color={FONT_COLOR.NEUTRAL3}>{"Add a language"}</FontBody1></div>
                <div><FontBody1 color={FONT_COLOR.NEUTRAL12}>{"Follow these steps to add translation support for a new language:"}</FontBody1></div>
                <div className="add-language-wizard-modal-stepper">
                    <AddLanguageWizardStepper totalSteps={wizardStore.steps.length} activeStepIndex={wizardStore.currentStepIndex} />
                </div>
                <div className="add-language-wizard-modal-content">
                    {wizardStore.currentStep === ADD_LANGUAGE_WIZARD_STEPS.SELECT_LANGUAGE && <SelectLanguageStep wizardStore={wizardStore} />}
                    {wizardStore.currentStep === ADD_LANGUAGE_WIZARD_STEPS.DOWNLOAD_CSV && <DownloadTranslationsStep wizardStore={wizardStore} />}
                    {wizardStore.currentStep === ADD_LANGUAGE_WIZARD_STEPS.UPLOAD_CSV && <UploadTranslationsStep wizardStore={wizardStore} />}
                </div>
                 <div className="add-language-wizard-modal-buttons">
                    <Button
                        text={wizardStore.cancelButtonTranslation}
                        onClick={() => localesListStore.setIsAddLanguageWizardOpen(false)}
                        disabled={isLoading}
                        variant={BUTTON_VARIANTS.Tertiary}
                        />
                    <Button 
                        text={wizardStore.submitButtonTranslation} 
                        onClick={wizardStore.nextStep}
                        variant={BUTTON_VARIANTS.Primary}
                        hasLoader={true}
                        disabled={!wizardStore.canMoveToNextStep}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </DefaultModalLayout>
    );

});

export default AddLanguageWizardModal;